import React from "react";
import SectionWithConfigurableHeader$ from "@deosite/sections/SectionWithConfigurableHeader";

const SectionWithConfigurableHeader = props => (
  <SectionWithConfigurableHeader$ {...props} />
);

export default SectionWithConfigurableHeader;
